import { CollectionService } from './index';
import axiosClient from '../http/axios-client';

const AdminToolUserService = CollectionService('admin-tool-users');

AdminToolUserService.getAdminToolUsersNumber = () => {
  return axiosClient.get('admin-tool-users/count');
};

AdminToolUserService.updateAdminToolUserDetails = (payload) => {
  return axiosClient.put('admin-tool-users/me/details', payload);
};

export default AdminToolUserService;
